module.exports = __webpack_public_path__ + "static/media/robogoose-mint.26455f9d.png";